import script from "./AlertRouting.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertRouting.vue?vue&type=script&setup=true&lang=js"

import "./AlertRouting.vue?vue&type=style&index=0&id=890f7f0c&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebase\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-890f7f0c"]])

export default __exports__